import script from "./UserDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./UserDashboard.vue?vue&type=script&setup=true&lang=js"

import "./UserDashboard.vue?vue&type=style&index=0&id=102b2ddd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-102b2ddd"]])

export default __exports__